import { FETCH_PRODUCTS, FETCH_ADDRESS_SUBSCRIPTION_PRODUCTS, FETCH_DOMICILIATION_PRODUCTS_ALL_ACCOUNTS } from '../actions/index'

interface ProductsReducer {
  products: Product[]
  subscriptionProducts: {
    addressId: number | null
    products: Product[]
  }
  domiciliationProductsAllAccounts: Product[]
}

const initialState: ProductsReducer = {
  products: [],
  subscriptionProducts: {
    addressId: null,
    products: [],
  },
  domiciliationProductsAllAccounts: [],
}

const products = (state = initialState, action: ReduxAction) => {
  switch (action.type) {
    case FETCH_PRODUCTS:
      return {
        ...state,
        products: [...action.products]
      }
    case FETCH_ADDRESS_SUBSCRIPTION_PRODUCTS:
      return {
        ...state,
        subscriptionProducts: {
          addressId: action.addressId,
          products: [...action.products],
        }
      }
    case FETCH_DOMICILIATION_PRODUCTS_ALL_ACCOUNTS:
      return {
        ...state,
        domiciliationProductsAllAccounts: [...action.products]
      }
    default:
      return state
  }
}

export default products
